module.exports = __webpack_public_path__ + "img/img_skin_1.abdcac55.png";